import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { TopDynamicTab } from "../../pages/Participants/TopDynamicTab";
import { useLocation } from "react-router-dom";
import { DynamicTabb } from "../DynamicTab/DynamicTab";

export const ImageViewer = () => {
  const location = useLocation();
  const DynamicTab = useSelector((store) => store.Home?.DynamicTab ?? []);

  const tabData = DynamicTab.find((t) => t.Offender === "/image-viewer");
  const image = location.state?.image || tabData?.image;
  // console.log("dynamicParticipatTab", DynamicTab);
  // console.log("tabData", tabData);
  //   const [tabSwitch, setTabSwitch] = useState(2);
  //   const location = useLocation();

  //   const imageFromNav = location.state?.image;

  //   const { dynamicParticipatTab } = useSelector((store) => store.participate);
  //   const [image, setImage] = useState(0);

  //   // useEffect(() => {
  //   //   dynamicParticipatTab.map((val) => {
  //   //     if (val.Offender === "/image-viewer") {
  //   //       setImage(val?.image);
  //   //     }
  //   //   });
  //   // }, []);
  //  useEffect(() => {
  //   console.log("dynamicParticipatTab:", dynamicParticipatTab);
  //   dynamicParticipatTab.forEach((val) => {
  //     if (val.Offender === "/image-viewer") {
  //       console.log("Found image:", val?.image?.slice(0, 50));
  //       setImage(val?.image);
  //     }
  //   });
  // }, [dynamicParticipatTab]);

  //   useEffect(() => {
  //   console.log("Image state updated:", image?.slice?.(0, 50));
  // }, [image]);

  return (
    <>
      <div
        style={{
          marginTop: "1.1%",
          backgroundColor: "var(--dynamicTabHeader)",
          borderRadius: "5px",
          overflow: "hidden",
          height: "87vh",
        }}
      >
        {/* <TopDynamicTab setTabSwitch={setTabSwitch} tabSwitch={tabSwitch} text={dynamicParticipatTab} /> */}
        <DynamicTabb />
        <div className="screen_num" style={{ margin: ".5%" }}>
          <p>IV.1</p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "82vh",
          }}
        >
          {/* <img
            src={"data:image/jpeg;base64," + encodeURI(image)}
            style={{
              height: "100%",
              objectFit: "cover",
            }}
          /> */}
          {/* <img src={`data:image/jpeg;base64,${image}`} style={{ height: "100%", objectFit: "cover" }} /> */}
          {image ? (
            <img src={`data:image/jpeg;base64,${image}`} style={{ height: "100%", objectFit: "cover" }} />
          ) : (
            <p>No image found</p>
          )}
        </div>
      </div>
    </>
  );
};
